import React, { createContext, useState, useEffect, useRef } from 'react';
import { notificationAPI } from '../api/api';
import { Toast } from 'primereact/toast';

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);
    const [unreadList, setUnreadList] = useState([])
    const [unreadCount, setUnreadCount] = useState(0);
    const toast = useRef(null);

    // Функция для загрузки оповещений с сервера
    const loadNotifications = async () => {
        try {
            const { data } = await notificationAPI.getAllNotifications();
            const result = JSON.parse(data);
            if(result.isSucccess){
                setNotifications(result.data);
                updateUnreadCount(result.data);
            }
            else{
                toast.current.show({
                    severity: 'error',
                    summary: 'Помилка при завантаженні сповіщень',
                    detail: `${result.message}`,
                    life: 3000
                });
            }
        } catch (error) {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Помилка при завантаженні сповіщень',
                    detail: error.message,
                    life: 3000
                });
            }
        }
    };

    // Функция для обновления кол-ва непрочитанных сообщений
    const updateUnreadCount = (notifications) => {
        const unread = notifications.filter(notification => !notification.IsRead);
        setUnreadList(unread)
        setUnreadCount(unread.length);
    };

    // Загрузка оповещений при первом запуске приложения
    useEffect(() => {
        loadNotifications();
    }, []);

    return (
        <NotificationContext.Provider value={{ notifications, unreadCount, unreadList, loadNotifications }}>
            {children}
            <Toast ref={toast} /> 
        </NotificationContext.Provider>
    );
};
